import MapSection from "@/components/MapSection";
import Reveal from "@/components/Reveal";
import useDocumentMeta from "@/hooks/useDocumentMeta";
import { Link } from "react-router-dom";

export default function AboutPage() {
  useDocumentMeta();
  return (
    <>
      <section className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-12" data-testid="about-hero">
        <div className="overline">About</div>
        <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl tracking-tight leading-[0.95] mt-4 max-w-4xl">
          About our caravan park in Ballarat <em className="italic font-light">— a small park with long memories.</em>
        </h1>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24">
        <div className="grid md:grid-cols-12 gap-12">
          <Reveal className="md:col-span-7 text-sa-ink2 text-lg leading-relaxed space-y-6">
            <p>
              Shady Acres has worn the same quiet character for nearly half a century. The land first came to life as a boy scout camp — generations of Ballarat kids pitched tents under the same gums that shade your site today. Over the decades it grew into a working caravan park, hosting families, road-trippers and long-stay travellers on twelve acres of mature blue gums in Warrenheip, on the eastern edge of Ballarat directly off the M8. Time has weathered it gently, but the park keeps its original feel — old, honest, and still very much itself.
            </p>
            <p>
              Today, Shady Acres is one of regional Victoria's most-loved boutique caravan parks. Whether you're after{" "}
              <Link to="/accommodation" className="text-sa-accent hover:text-sa-accentHover">cabins in Ballarat</Link>, a powered caravan site, or a quiet camping pitch, we hope you'll come and stay.
            </p>
          </Reveal>
          <Reveal delay={120} className="md:col-span-5">
            <div className="bg-white border border-sa-ink/10 rounded-2xl p-8 sticky top-28">
              <div className="overline">At a glance</div>
              <dl className="mt-6 space-y-4 text-[15px]">
                {[
                  ["Location", "Warrenheip, Ballarat VIC"],
                  ["Distance from Melbourne", "~110km / 90 min"],
                  ["Park size", "12 acres"],
                  ["Accommodation", "Cabins · Caravan · Camping"],
                  ["Things to do", "Hike Sovereign Hill, Lake Wendouree"],
                  ["Heritage", "Nearly half a century"],
                ].map(([k, v]) => (
                  <div key={k} className="flex items-center justify-between border-b border-sa-ink/10 pb-3">
                    <dt className="text-sa-ink2 text-sm">{k}</dt>
                    <dd className="text-sa-ink font-medium">{v}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>
        </div>
      </section>

      <MapSection />
    </>
  );
}
